
document.addEventListener('DOMContentLoaded',function(){

  let product = new Vue({
    el: '#app',
    data(){
      return {
        comingSoonCSVPath: './data/new/comingsoon.csv',
        noticeAPIPath: '/sw/api/auth/V1/SWFR070580.seam',
        location: new URL(window.location.href),
        isMounted: false,
        today: new Date(),
        allProducts: [],
        weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan.','Feb.','Mar.','Apr.','May','Jun.','Jul.','Aug.','Sep.','Oct.','Nov.','Dec.'],
        days: [],
        currentFlag: 0,
        showModal: false,
        showModalItemJAN: '',
        showModalItem: [],
        showModalDateIndex: 0,
        modalDisplayId: 1,
        noticeMailCheck: false,
        noticeLineCheck: false,
        tabCurrent: 'soon0',
        noticeAPIURL: '',
      }
    },
    watch: {
      currentFlag: function(){
        this.getCalendarDays(this.currentYear, this.currentMonth);
      },
      showModalItemJAN: function(newJAN){
        let modalItem = this.allProducts.filter(function(product){
          return product.janCode === newJAN;
        })
        this.showModalItem = [...modalItem];
      },
      comingSoonDates: function(newDays){
        this.getCalendarDays(this.currentYear,this.currentMonth);
      },
    },
    computed: {
      thisYear(){
        // 今年の年取得
        return this.today.getFullYear();
      },
      thisMonth(){
        // 今月の月取得
        return this.today.getMonth() + 1;
      },
      nextMonth(){
        // 来月の月取得
        return (this.thisMonth !== 12) ? this.thisMonth + 1 : 1;
      },
      nextMonthYear(){
        // 来月の年取得
        return (this.thisMonth !== 12) ? this.thisYear : this.thisYear + 1;
      },
      currentMonth(){
        let thisMonth = this.calendarMonths[this.currentFlag];
        return thisMonth.split('/')[1];
      },
      currentMonthDisplay(){
        return this.months[this.currentMonth - 1];
      },
      currentYear(){
        let thisMonth = this.calendarMonths[this.currentFlag];
        return thisMonth.split('/')[0];
      },
      prevBtn(){
        if (this.currentFlag === 0) {
          return true
        } else {
          return false
        }
      },
      nextBtn(){
        if (this.currentFlag === this.calendarMonths.length - 1){
          return true
        } else {
          return false
        }
      },
      comingSoonLimitDate(){
        // 再来月の初日取得
        // return new Date(this.nextMonthYear, this.nextMonth, 1);
        // 今日から51日後（この日発売のものまでは表示）
        const date = new Date();
        date.setDate(date.getDate() + 51);
        console.log(date);

        return date;
      },
      allDates(){
        // 全発売日配列
        let dates = this.allProducts.map(item => item.date);
        dates = Array.from(new Set(dates));
        return dates;
      },
      newItemsDates(){
        // 発売日配列を日付データに変換
        let allDates = this.allDates.map(item => new Date(item));
        // カレンダーにプロットする日付
        let dates = allDates.filter(date => date.getTime() <= this.today.getTime());
        dates = dates.map(date => date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate());
        return dates;
      },
      comingSoonDates(){
        // 発売日配列を日付データに変換
        let allDates = this.allDates.map(item => new Date(item));
        // カレンダーにプロットする日付
        let dates = allDates.filter(date => date.getTime() > this.today.getTime() && date.getTime() < this.comingSoonLimitDate.getTime());
        dates = dates.map(date => date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate());
        return dates;
      },
      calendarMonths(){
        let dates = [this.thisYear + '/' + this.thisMonth + '/'];
        dates =  dates.concat(this.comingSoonDates);
        dates = dates.map(date => date.split('/', 2).join('/'));
        dates = Array.from(new Set(dates));
        return dates;
      },
      comingSoonProducts(){
        let dates = [...this.comingSoonDates];
        let comingSoonProducts = [];
        for (let i = 0; i < dates.length; i++){
          comingSoonProducts[i] = {
            'date': dates[i],
            'displayDate': dates[i].slice(5).replace('/','.'),
            'products': this.allProducts.filter(function(product){
              return product.date === dates[i];
            })
          };
        }
        return comingSoonProducts
      },
    },
    mounted(){
      Promise.all([
        this.getCSV(this.comingSoonCSVPath),
      ]).then(function(values) {
        this.comingSoonProducts = values[0];
      });
      this.noticeAPIURL = 'https://' + this.location.hostname + this.noticeAPIPath;

      // 開発用
      if (this.location.hostname.indexOf('shiseido.co.jp') === -1) {
        this.noticeAPIURL = './_dev/testdata/apitest_success.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err1.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err2.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err3.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err4.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err5.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err6.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_err7.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_gyomuerr.json';
        // this.noticeAPIURL = './_dev/testdata/apitest_syserr.json';
      }

      setTimeout(() => this.isMounted = true, 10);
    },
    methods: {
      async getCSV(CSVpath){
        const response = await fetch(CSVpath,{
          method: 'GET',
          mode: 'cors',
        });
        let data = await response.text();
        data = data.split('\r\n');
        const headers = data.shift().split(',');
        const rows = data;
        const arr = await rows.map(function(row) {
          const values = row.split(',');
          const el = headers.reduce(function(obj, header, i) {
            const value = values[i];
            obj[header] = value;
            return obj
          },{}
          );
          return el;
        });
        arr.map(function(item){
          item.taxinPrice = Number(item.taxinPrice).toLocaleString();
          console.log(item.date);
          item.displayDate = item.date.slice(5).replace('/','.');
          item.noticeMail = false;
          item.noticeLine = false;
        });
        this.allProducts = arr;
        return arr;
      },
      getCalendarDays(year,month){
        let dateArr = [];
        const startDate = new Date(year, month - 1, 1) // 月の１日を取得
        const endDate = new Date(year, month,  0) // 月のみそかを取得
        const endDayCount = endDate.getDate() // 月のみそかの日付を取得（28?29?30?31?）
        const lastMonthEndDate = new Date(year, month - 1, 0) // 前月のみそかを取得
        const lastMonthendDayCount = lastMonthEndDate.getDate() // 前月のみそかの日付を取得（28?29?30?31?）
        const startDay = startDate.getDay() // 月の１日の曜日を取得（０始まり）
        let dayCount = 1 // 月の日にちのカウント
        for (let week = 0; week < 6; week++) {
          for (let day = 0; day < 7; day++) {
            if (week == 0 && day < startDay) {
              // 1行目で1日の曜日の前
              let num = lastMonthendDayCount - startDay + day + 1
              let date = {
                "year" : '',
                "month" : '',
                "day" : num,
                "disabled": true,
                "today": false,
              }
              dateArr.push(date);
              // console.log(dateArr);
            } else if (dayCount > endDayCount) {
              // 末日の日数を超えた
              let num = dayCount - endDayCount
              let date = {
                "year" : '',
                "month" : '',
                "day" : num,
                "disabled": true,
                "today": false,
              }
              dateArr.push(date);
              // console.log(dateArr);
              dayCount++
            } else {
              let date = {
                "year" : year,
                "month" : month,
                "day" : dayCount,
                "disabled": false,
                "today": false,
              }

              let thisDate = `${year}/${month}/${dayCount}`;
              // 発売済みがあるかどうか
              if (this.newItemsDates.indexOf(thisDate) !== -1) {
                date.released = true;
              } else {
                date.released = false;
              }
              // 発売があるかどうか
              if (this.comingSoonDates.indexOf(thisDate) !== -1) {
                date.release = true;
                date.tabIndex = this.comingSoonDates.indexOf(thisDate);
              } else {
                date.release = false;
              }
              // 本日かどうか
              if (thisDate === this.today.toLocaleString().split(' ')[0]) {
                date.today = true;
              }
              // console.log(this.today.toLocaleString().split(' ')[0])
              dateArr.push(date);
              // console.log(dateArr);
              dayCount++
            }
          }
          if(dayCount > endDayCount){
            break;
          }
        }
        this.days = [...dateArr];
      },
      changeCalendar(num){
        this.currentFlag = num;
      },
      modalOpen(jan,index){
        this.showModal = true;
        this.showModalItemJAN = jan;
        this.showModalDateIndex = index;
      },
      modalClose(){
        this.noticeMailCheck = false;
        this.noticeLineCheck = false;
        this.showModal = false;
        this.modalDisplayId = 1;
      },
      async sendNotice(jan, haisin_kbn){
        // haisin_kbn = 1:メール、2:LINE

        // 計測用
        if (haisin_kbn === 1) {
          _sc.gene_click('otherlink_' + jan + '_mail', this.noticeAPIPath);
        } else {
          _sc.gene_click('otherlink_' + jan + '_line', this.noticeAPIPath);
        }

        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        let raw = JSON.stringify({
          "sweb_shohin_cd": jan,
          "haisin_kbn": haisin_kbn
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };

        const response = await fetch(this.noticeAPIURL, requestOptions);

        let data = await response.json();

        console.log(typeof(data.status));

        try {

          if (Number(data.status) === 500) {
            if (data.details) {
              const errorCode = String(data.details[0].code);
              if (errorCode === 'SWFRW070500') {
                // 未ログイン err1
                if (haisin_kbn === 1) { // メール
                  location.href = '/sw/SWFG014000.seam?_kss_next_url=' + this.location;
                } else if (haisin_kbn === 2) { // LINE
                  location.href = '/sw/member/auth/SWFG012500.seam?l=wa&olsnew=1';
                }
              } else if (errorCode === 'SWFRW070510') {
                // 未LINEコネクト err2
                location.href = '/sw/member/auth/SWFG012500.seam?l=wa&olsnew=1';
              } else if (errorCode === 'SWFRW070520') {
                // 該当商品なし err3
                this.modalDisplayId = 3;
              } else if (errorCode === 'SWFRW070530') {
                // 通知登録期間外 err4
                this.modalDisplayId = 4;
              } else if (errorCode === 'SWFRW070550') {
                // 配信区分不正 err6
                this.modalDisplayId = 3;
              } else if (errorCode === 'SWFRW070560') {
                // 配信先不備 err7
                this.modalDisplayId = 6;
              } else if (errorCode === 'SWFRW070540') {
                // すでに登録済み err5
                this.modalDisplayId = 5;
                this.addRegistFlag(jan, haisin_kbn);
              } else {
                this.modalDisplayId = 3;
              }
            } else {
              // システムエラー syserr,jan/kbn不正 gyomuerr
              this.modalDisplayId = 3;
            }
          }

          // 通知登録成功
          if (data.status_code === '0') {
            this.completeRegist(jan, haisin_kbn);
          }

        } catch (error) {
          this.modalDisplayId = 3;
        }

      },
      track(id, url){
        console.log(id)
        console.log(url);
        _sc.gene_click(id, url);
      },
      tabSwitch(tabId){
        this.tabCurrent = tabId;
        const tabContainerArr = Array.from(document.querySelectorAll('.comingsoon-tab'));
        const tabLeftSpaceWidth = document.querySelector('.comingsoon-tab div:nth-child(1)').offsetLeft;
        const tabIndex = Number(tabId.replace('soon','')) <= 2 ? 1 : Number(tabId.replace('soon','')) - 1;
        tabContainerArr.forEach(tab => {
          let currentTabLeft = tab.querySelector('div:nth-child(' + tabIndex + ')').offsetLeft;
          tab.scrollTo({
            left: currentTabLeft - tabLeftSpaceWidth,
            behavior: 'smooth',
          })
        });
        const anchorTarget = document.getElementById('soon');
        const commonHeader = document.querySelector('header .header__block');
        if (anchorTarget) {
          window.scrollTo({
            top: anchorTarget.offsetTop - commonHeader.clientHeight,
            behavior: 'smooth',
          });
        }
      },
      addRegistFlag(jan, haisin_kbn){
        for (let i = 0; i < this.comingSoonProducts[this.showModalDateIndex].products.length; i ++) {
          if (this.comingSoonProducts[this.showModalDateIndex].products[i].janCode === jan) {
            if (haisin_kbn === 1) { // メール
              this.comingSoonProducts[this.showModalDateIndex].products[i].noticeMail = true;
            }
            if (haisin_kbn === 2) { // LINE
              this.comingSoonProducts[this.showModalDateIndex].products[i].noticeLine = true;
            }
          }
        }
      },
      completeRegist(jan, haisin_kbn){
        this.addRegistFlag(jan, haisin_kbn);
        this.modalDisplayId = 2;
      },
      newItemAnchor(){
        const anchorTarget = document.getElementById('new');
        const commonHeader = document.querySelector('header .header__block');
        if (anchorTarget) {
          window.scrollTo({
            top: anchorTarget.offsetTop - commonHeader.clientHeight,
            behavior: 'smooth',
          });
        }
      },
    },
  });

});

